import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyA4bum6OcOrKd1h9OfMkp97b-QQVkHS6UE',
  authDomain: 'monetech-servicios.firebaseapp.com',
  projectId: 'monetech-servicios',
  storageBucket: 'monetech-servicios.firebasestorage.app',
  messagingSenderId: '1061021858252',
  appId: '1:1061021858252:web:61c8377c7f1affaa170569',
  measurementId: 'G-64MXTKXS80',
};

const vapidKey =
  'BLyBRIE82jfmAT0YYiSZkSYedEbHsmlodDEgA3EA0okdlpZO_dj73H7iuC-n_cW9EJu-CfDh-ztGuWCEDB2b1SE';

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);
const analyticsFirebase = getAnalytics(firebaseApp);

export { messaging, getMessaging, getToken, onMessage, vapidKey, analyticsFirebase };
